module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "main-gray-back"
  }, [_c('van-form', {
    on: {
      "submit": _vm.onSubmit
    }
  }, [_c('van-field', {
    attrs: {
      "input-align": "right",
      "readonly": "",
      "name": "选择商品",
      "label": "选择商品",
      "placeholder": "选择商品",
      "rules": [{
        required: true,
        message: '请选择商品'
      }]
    },
    on: {
      "click": function($event) {
        _vm.goods_show = true
      }
    },
    model: {
      value: (_vm.formData.goods_name),
      callback: function($$v) {
        _vm.$set(_vm.formData, "goods_name", $$v)
      },
      expression: "formData.goods_name"
    }
  }), _vm._v(" "), _c('van-field', {
    attrs: {
      "readonly": "",
      "input-align": "right",
      "name": "选择规格",
      "label": "选择规格",
      "placeholder": "选择规格"
    },
    on: {
      "click": _vm.onGoodsSkuPicker
    },
    model: {
      value: (_vm.formData.sku_name),
      callback: function($$v) {
        _vm.$set(_vm.formData, "sku_name", $$v)
      },
      expression: "formData.sku_name"
    }
  }), _vm._v(" "), _c('van-field', {
    attrs: {
      "input-align": "right",
      "name": "商品数量",
      "label": "商品数量",
      "placeholder": "商品数量"
    },
    model: {
      value: (_vm.formData.goods_count),
      callback: function($$v) {
        _vm.$set(_vm.formData, "goods_count", $$v)
      },
      expression: "formData.goods_count"
    }
  }), _vm._v(" "), _c('van-field', {
    attrs: {
      "input-align": "right",
      "name": "商品金额",
      "label": "商品金额",
      "placeholder": "商品金额"
    },
    model: {
      value: (_vm.formData.goods_price),
      callback: function($$v) {
        _vm.$set(_vm.formData, "goods_price", $$v)
      },
      expression: "formData.goods_price"
    }
  }), _vm._v(" "), _c('div', {
    staticStyle: {
      "margin": "16px"
    }
  }, [_c('van-button', {
    attrs: {
      "round": "",
      "block": "",
      "type": "info",
      "native-type": "submit"
    }
  }, [_vm._v("提交")])], 1)], 1), _vm._v(" "), _c('LoginDialog', {
    attrs: {
      "show": _vm.loginShow
    },
    on: {
      "loginSuccess": _vm.loginSuccess,
      "loginCancel": _vm.loginCancel
    }
  }), _vm._v(" "), _c('van-popup', {
    style: ({
      height: '100%'
    }),
    attrs: {
      "position": "bottom"
    },
    model: {
      value: (_vm.goods_show),
      callback: function($$v) {
        _vm.goods_show = $$v
      },
      expression: "goods_show"
    }
  }, [_c('div', {
    staticClass: "goods-box"
  }, [_c('van-sticky', [_c('div', {
    staticClass: "flex-between"
  }, [_c('van-search', {
    staticStyle: {
      "flex": "1"
    },
    attrs: {
      "placeholder": "请输入搜索关键词"
    },
    on: {
      "input": _vm.onSearchInput
    },
    model: {
      value: (_vm.value),
      callback: function($$v) {
        _vm.value = $$v
      },
      expression: "value"
    }
  }), _vm._v(" "), _c('van-icon', {
    staticStyle: {
      "margin-right": "0.2rem"
    },
    attrs: {
      "size": "0.6rem",
      "color": "#323233",
      "name": "cross"
    },
    on: {
      "click": _vm.onClsoePopup
    }
  })], 1)]), _vm._v(" "), _c('van-list', {
    attrs: {
      "finished-text": "没有更多了"
    },
    model: {
      value: (_vm.loading),
      callback: function($$v) {
        _vm.loading = $$v
      },
      expression: "loading"
    }
  }, _vm._l((_vm.goodsOption), function(item) {
    return _c('van-cell', {
      key: item.id,
      attrs: {
        "title": item.title
      },
      on: {
        "click": function($event) {
          return _vm.onGoodsChange(item)
        }
      }
    })
  }), 1)], 1)]), _vm._v(" "), _c('div', {
    staticClass: "sku-container"
  }, [_c('van-sku', {
    attrs: {
      "sku": _vm.skuData.sku,
      "goods": _vm.skuData.goods,
      "goods-id": _vm.skuData.goods_id,
      "quota": _vm.skuData.quota,
      "quota-used": _vm.skuData.quotaUsed,
      "hide-stock": _vm.skuData.hide_stock,
      "close-on-click-overlay": _vm.closeOnClickOverlay,
      "message-config": _vm.messageConfig,
      "show-add-cart-btn": false,
      "buy-text": "确定"
    },
    on: {
      "buy-clicked": _vm.onGoodsSkuSave
    },
    model: {
      value: (_vm.showSkuPicker),
      callback: function($$v) {
        _vm.showSkuPicker = $$v
      },
      expression: "showSkuPicker"
    }
  }, [_c('span', {
    attrs: {
      "slot": "sku-stepper"
    },
    slot: "sku-stepper"
  })])], 1)], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-a4a0eeca","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/page/apps/configure/SaleGoodsAdd.vue
// module id = 2559
// module chunks = 0